import { ConnectorStatus } from '@/state/types';

const COLOR_BY_STATUS: Record<string, string> = {
  [ConnectorStatus.Available]: 'bg-primary-base',
  [ConnectorStatus.Preparing]: 'bg-cyan-400',
  [ConnectorStatus.Charging]: 'bg-primary-base animate-pulse',
  [ConnectorStatus.SuspendedEV]: 'bg-amber-300',
  [ConnectorStatus.SuspendedEVSE]: 'bg-amber-500',
  [ConnectorStatus.Finishing]: 'bg-cyan-200',
  [ConnectorStatus.Reserved]: 'bg-purple-400',
  [ConnectorStatus.Unavailable]: 'bg-slate-600',
  [ConnectorStatus.Faulted]: 'bg-rose-500',
};

export function ConnectorLED({ status }: { status: ConnectorStatus }): JSX.Element {
  const color = COLOR_BY_STATUS[status] ?? 'bg-slate-600';
  return (
    <span
      aria-label={`Connector status: ${status}`}
      role="status"
      className={`inline-block h-3 w-3 rounded-full ${color}`}
    />
  );
}
